import { EnhancedStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';

export const createPersistor = <S>(store: EnhancedStore<S>) => persistStore(store);
